import { AvatarSize, MiddleEllipsisWhisper, cn } from '@aleph/shared-components';
import RedditEntityImage, { RedditImageEntity } from 'wb-reddit/app/common/components/entityImage';
import { AuthGraphAdvertiserListQueryItems } from 'wb-spotify/graphql/authgraph/generated';

interface IProps {
	onClick?: () => void
	name: string
	entity: RedditImageEntity | AuthGraphAdvertiserListQueryItems
	classname?: string
}

function EntityName({
	onClick, name, entity, classname = '',
}: IProps) {
	const className = cn(
		`flex flex-1 items-center px-[5px] gap-[14px] group overflow-hidden text-[16px]
		font-medium text-gray-950`,
		{
			'cursor-pointer hover:text-blue focus:text-blue focus:outline-none': onClick,
			'pointer-events-none cursor-default':                                !onClick,
		},
		classname,
	);

	return (
		<button
			onClick={onClick}
			className={className}
		>
			<RedditEntityImage
				entity={entity}
				size={AvatarSize.Medium}
			/>
			<div className="overflow-hidden w-full text-left">
				<MiddleEllipsisWhisper value={name} />
			</div>
		</button>
	);
}

export default EntityName;
